// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"V0-z","subtitle":"W0-z","wrapper":"X0-z","leftArrow":"Y0-z","rightArrow":"Z0-z"};